export const NameCell = ({ value }: { value?: string }) => {
  return (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.2',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {(value as string) || '-'}
    </div>
  )
}
